import {ref} from 'vue';

export default {
    install: (app, options) => {
        const project = ref(null);

        const setSessionAttachedFilesProject = (value) => {
            project.value = value;
        };

        const getSessionAttachedFilesProject = () => {
            return project;
        };

        const flashAttachedFilesProject = () => {
            const result = ref(project.value);

            project.value = null;

            return result;
        };

        app.provide('setSessionAttachedFilesProject', setSessionAttachedFilesProject);
        app.provide('getSessionAttachedFilesProject', getSessionAttachedFilesProject);
        app.provide('flashAttachedFilesProject', flashAttachedFilesProject);
    },
}
